import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, errText, withRetry } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    api.post("/auth/session", { session_id: sessionId })
      .catch((e) => {
        if (e.response) throw e;
        return withRetry(() => api.post("/auth/session", { session_id: sessionId }));
      })
      .then(({ data }) => {
        setSession(data.user, data.session_token);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user: data.user } });
      })
      .catch((e) => {
        const msg = e.response ? errText(e) : "Connection hiccup while signing in — the workspace was waking up. Please tap Continue with Google again.";
        navigate("/login", { replace: true, state: { error: msg } });
      });
  }, [navigate, setSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <img src="/logo.png" alt="" className="w-16 h-16 animate-pulse rounded-full" />
    </div>
  );
}
